import { DialogContent } from '@mui/material';

const DialogBody = ({
  children,
  padding = { xs: '8px', sm: '16px', md: '24px' },
  sx = {},
  ...props
}) => {
  return (
    <DialogContent
      sx={{
        padding: padding,
        ...sx,
      }}
      {...props}
    >
      {children}
    </DialogContent>
  );
};

export default DialogBody;
